// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"9d132923","936":"2e547be3"}[chunkId] + ".chunk.js";
};